// extracted by css-extract-rspack-plugin
export default {"ErrorFallback":"ErrorFallback_ErrorFallback__0ixdr"};